import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import $ti from '../ti.js'

import * as _ from "../components/index.js";
import templates from "./templates.js";

class Favs extends Component {
  constructor(props) {
    super(props);

    let templates = Globals.Templates();
    let favs = this.getFavs();
    let questions = Object.keys(favs).map((fav) => {
      return this.findQuestionById(templates, fav)
    })

    this.state = {
      templatesTotal: templates ? Object.keys(templates).length : 0,
      templates: templates ? templates : {},
      data: favs,
      lang: props.app.lang,
      questions: questions,
      answers: this.getAnswers(),
      exp: this.getExp()
    };
  }

  componentDidMount() {

  }

  findQuestionById(templates, id) {
    let rt = [];
    let finded = false;
    for (let i = 0; i < Object.keys(templates).length; i++) {
      let template = templates[i];
      for (var m = 0; m < template.questions.length; m++) {
        let question = template.questions[m];
        if (question.id == id) {
          rt = question;
          finded = true;
          break;
        }
      }
      if (finded) {
        break;
      }
    }
    return rt;
  }

  getFavs = () => {
    let favs = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      Object.keys(templates).map(template => {
        templateIds[templates[template].number] = 1;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(id);
        })
        favs = { ...favs, ...tmp }
      }
    })
    return favs;
  }

  getExp = () => {
    let exp = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      let i = 0;
      Object.keys(templates).map(template => {
        templateIds[i] = 1;
        i++;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_exp_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(tmp[fav]);
        })
        exp = { ...exp, ...tmp }
      }
    })
    return exp;
  }

  getAnswers = () => {
    let answers = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      let i = 0;
      Object.keys(templates).map(template => {
        templateIds[i] = 1;
        i++;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_answers_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(tmp[fav]);
        })
        answers = { ...answers, ...tmp }
      }
    })
    return answers;
  }

  render() {
    let lang = this.state.lang
    let data = this.state.data;
    let questions = this.state.questions;
    let templateClass;
    let question;
    return (
      <>
        <_.Header title="Избранное" />

        <section class="menu">
          <div class="mb-2">
            <span>Избранных вопросов: </span>
            <span> {Object.keys(data).length}</span>
          </div>
          {data ? Object.keys(data).map((key, index) => {
            templateClass = 'favorite_item'
            question = questions[index];
            if (this.state.answers[question.id]) {
              if (question.correctId == this.state.answers[question.id]) {
                templateClass += ' border-success';
              } else {
                templateClass += ' border-danger';
              }
            } else if (this.state.exp[question.id]) {
              templateClass += ' border-warning';
            }

            return <a href={`/fav/${questions[index].id}`} class={templateClass}>
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="blue_text" style="">Вопрос {((parseInt(this.state.templates[(questions[index].templateId -1)].title.replace('# ','')) -1) * 20) + questions[index].ord}</span>
                </div>
                <i class="demo-icon icon-angle-right right_icon"></i>
              </div>
              <span class="font14 gray_text" dangerouslySetInnerHTML={{ __html: questions[index].question ? questions[index].question[lang] : null }}></span>
            </a>
          }) : null}

        </section>
        {Object.keys(data).length > 0 ? 
          <div class="marathon_button">
            <a class="" href="/fav/test/" role="button">Начать тест</a>
          </div>
        : null}
      </>
    );
  }
}

export default GlobState.connect(Favs, Globals)